import React from 'react'
import { CChartLine } from '@coreui/react-chartjs'

// Placeholder traffic chart shown when a view has no analytics data of its own.
export default function MainChartExample({ style, labels = [], data = [] }) {
    return (
        <div style={style}>
            <CChartLine
                data={{
                    labels: labels.length ? labels : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    datasets: [{
                        label: 'Visitors',
                        data: data.length ? data : [0, 0, 0, 0, 0, 0, 0],
                        borderColor: '#4facfe',
                        backgroundColor: 'rgba(79, 172, 254, 0.15)',
                        fill: true,
                        tension: 0.4,
                    }],
                }}
                options={{
                    maintainAspectRatio: false,
                    plugins: { legend: { display: false } },
                    scales: { y: { beginAtZero: true } },
                }}
            />
        </div>
    )
}
